<template>
	<article class="faq-page">
		<page-header>
			<div class="faq__header">
				<p class="faq__header__total">
					총 등록 ({{ totalCount }}) ㅣ 노출 ({{ displayCount }}) ㅣ
					비노출 ({{ unDisplayCount }})
				</p>
				<router-link
					class="btn blue faq__header__link"
					to="/operation/faq"
					>등록</router-link
				>
			</div>
		</page-header>

		<managing-section :is-table="true">
			<horizontal-search
				:block-elem="true"
				@search="search(true)"
				@init="initPage"
			>
				<select-input
					ref="question"
					placeholder="입력하세요"
					label="제목"
				/>
				<select-input
					ref="faqsDate"
					:use-period="true"
					label="등록일"
				/>
			</horizontal-search>
		</managing-section>

		<managing-section :is-table="true">
			<template slot="infoSection">
				<span class="section__info__left"></span>
				<div class="section__info__right">
					<div class="section__info__items">
						<selector
							v-model="staticCode"
							title="분류"
							valueKey="id"
							:option-list="staticCodeList"
							@input="search(true)"
						/>
					</div>
					<div class="section__info__items">
						<selector
							v-model="isDisplay"
							title="노출상태"
							:option-list="isDisplayList"
							@input="search(true)"
						/>
					</div>
					<div class="section__info__items">
						<selector
							v-model="createdBy"
							title="관리자"
							:option-list="createdByList"
							@input="search(true)"
						/>
					</div>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th class="faq__table__date">등록일</th>
						<th class="faq__table__type">분류</th>
						<th>제목</th>
						<th class="faq__table__priority">상위노출</th>
						<th class="faq__table__display">노출 상태</th>
						<th class="faq__table__admin">관리자</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.id">
						<td>{{ item.createdAt }}</td>
						<td>{{ item.staticCode }}</td>
						<td class="text-left">
							<router-link
								class="link"
								:to="`/operation/faq?id=${item.id}`"
							>
								{{ item.question }}
							</router-link>
						</td>
						<td>{{ item.isBest }}</td>
						<td>{{ item.isDisplay }}</td>
						<td>{{ item.nickName }}</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="totalCount"
				:limit="limit"
				:offset="offset"
				@to="paging"
			/>
		</managing-section>
	</article>
</template>
<script>
	import isEqual from 'lodash/isEqual';
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'FAQList',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			Selector,
			PaginationBox,
		},
		data() {
			return {
				staticCode: null,
				isDisplayList: [
					{ value: null, name: '전체' },
					{ value: 1, name: '노출' },
					{ value: 0, name: '비노출' },
				],
				isDisplay: null,
				createdByList: [],
				createdBy: null,
				offset: 0,
				limit: 10,
				totalCount: 0,
				displayCount: 0,
				unDisplayCount: 0,
				list: [],
			};
		},
		computed: {
			...mapGetters(['getListAddNull']),
			staticCodeList() {
				return this.getListAddNull('faqCategory');
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			async createdByListSet() {
				const { data } =
					await this.$axiosAdmin2.get('/v3/api/faq/writer');
				this.createdByList = data.reduce(
					(acc, item) => {
						acc.push({
							value: item.idRegister,
							name: item.nickName,
						});
						return acc;
					},
					[{ value: null, name: '전체' }]
				);
			},
			async setFilterList() {
				await Promise.all([this.createdByListSet()]);
			},
			setFilter() {
				const query = this.$route.query;
				Object.keys(query).forEach(key => {
					const value = query[key];
					switch (key) {
						case 'offset':
						case 'limit':
						case 'isDisplay':
						case 'createdBy':
							this[key] = Number(value);
							break;
						case 'question':
							this.$refs[key].inputModel = value;
							break;
						case 'staticCode':
							this[key] = value;
							break;
					}
				});
				if (query.faqsDateMin || query.faqsDateMax) {
					this.$refs.faqsDate.from = query.faqsDateMin
						? moment(query.faqsDateMin, 'x').format('YYYY-MM-DD')
						: '';
					this.$refs.faqsDate.to = query.faqsDateMax
						? moment(query.faqsDateMax, 'x').format('YYYY-MM-DD')
						: '';
				}
			},
			getParams(init) {
				const params = {
					offset: init ? 0 : this.offset,
					limit: this.limit,
				};
				const { from, to } = this.$refs.faqsDate;
				if (this.$refs.question.inputModel)
					params.question = this.$refs.question.inputModel;
				if (from)
					params.faqsDateMin = moment(from, 'YYYY-MM-DD').format('x');
				if (to)
					params.faqsDateMax = moment(to, 'YYYY-MM-DD')
						.endOf('date')
						.format('x');
				if (this.staticCode !== null)
					params.staticCode = this.staticCode;
				if (this.isDisplay !== null) params.isDisplay = this.isDisplay;
				if (this.createdBy !== null) params.createdBy = this.createdBy;
				return params;
			},
			setQuery(params) {
				const query = {};
				const curQuery = this.$route.query;
				Object.keys(params).forEach(key => {
					switch (key) {
						case 'offset':
						case 'limit':
						case 'isDisplay':
						case 'createdBy':
							query[key] = String(params[key]);
							break;
						case 'question':
						case 'staticCode':
						case 'faqsDateMin':
						case 'faqsDateMax':
							query[key] = params[key];
							break;
					}
				});
				if (isEqual(query, curQuery)) return;
				this.$router.replace({ query });
			},
			async search(init) {
				const params = this.getParams(init);
				const { data } = await this.$axiosAdmin2.get(
					'/v3/api/faq/list',
					{ params }
				);
				this.totalCount = Number(data.faqCount.totalCount);
				this.displayCount = Number(data.faqCount.displayCount);
				this.unDisplayCount = Number(data.faqCount.unDisplayCount);
				this.list = data.faqList.data.map(item => {
					item.createdAt = moment(item.createdAt).format(
						'YYYY.MM.DD HH:mm'
					);
					item.staticCode = this.staticCodeList.filter(
						staticCode => staticCode.id === item.staticCode
					)[0].name;
					item.isBest = item.isBest ? 'Y' : 'N';
					item.isDisplay = item.isDisplay ? '노출' : '비노출';
					return item;
				});
				this.setQuery(params);
			},
			async init() {
				await this.setFilterList();
				this.setFilter();
				this.search();
			},
			initPage() {
				this.$refs.question.inputModel = '';
				this.$refs.faqsDate.init();
				this.staticCode = null;
				this.isDisplay = null;
				this.createdBy = null;
				this.offset = 0;
				this.search();
			},
			paging({ offset }) {
				this.offset = offset;
				this.search();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.faq__header {
		display: flex;
		align-items: center;
	}

	.faq__header__total {
		font-size: 1rem;
	}

	.faq__header__link {
		margin-left: 12px;
	}

	.faq__table__date {
		width: 160px;
	}

	.faq__table__type {
		width: 120px;
	}

	.faq__table__priority,
	.faq__table__display {
		width: 90px;
	}

	.faq__table__admin {
		width: 110px;
	}
</style>
